import mixpanel from 'mixpanel-browser';

// Helper function to handle tracking with consistent error handling
const track = (eventName, properties = {}) => {
  try {
    mixpanel.track(eventName, {
      ...properties,
      timestamp: new Date().toISOString(),
    });
  } catch (error) {
    console.error(`Error tracking event ${eventName}:`, error);
  }
};

// Analytics service for tracking application events
const Analytics = {
  // User actions
  trackLogin: (userId, method = 'default') => {
    track('User Login', { userId, method });
  },
  
  trackLogout: (userId) => {
    track('User Logout', { userId });
  },
  
  trackRegistration: (userId, method = 'default') => {
    track('User Registration', { userId, method });
  },
  
  // Content interactions
  trackPageView: (pageName, path) => {
    track('Page View', { pageName, path });
  },
  
  trackButtonClick: (buttonName, pageName) => {
    track('Button Click', { buttonName, pageName });
  },
  
  trackFeatureUsage: (featureName, details = {}) => {
    track('Feature Usage', { featureName, ...details });
  },
  
  // Audio/video interactions
  trackMediaPlay: (mediaType, mediaId, mediaDuration) => {
    track('Media Play', { mediaType, mediaId, mediaDuration });
  },
  
  trackMediaPause: (mediaType, mediaId, playedDuration) => {
    track('Media Pause', { mediaType, mediaId, playedDuration });
  },
  
  trackMediaComplete: (mediaType, mediaId) => {
    track('Media Complete', { mediaType, mediaId });
  },
  
  // Chat/interaction tracking
  trackMessageSent: (messageType, recipientType, messageLength) => {
    track('Message Sent', { messageType, recipientType, messageLength });
  },
  
  trackMessageReceived: (messageType, senderType, messageLength) => {
    track('Message Received', { messageType, senderType, messageLength });
  },
  
  // Error tracking
  trackError: (errorType, errorMessage, componentName) => {
    track('Error Occurred', { errorType, errorMessage, componentName });
  },
  
  // Custom event tracking
  trackCustomEvent: (eventName, properties = {}) => {
    track(eventName, properties);
  },
  
  // User identity
  identifyUser: (userId, userProperties = {}) => {
    try {
      mixpanel.identify(userId);
      if (Object.keys(userProperties).length > 0) {
        mixpanel.people.set(userProperties);
      }
    } catch (error) {
      console.error('Error identifying user:', error);
    }
  },
  
  // Reset user
  resetUser: () => {
    try {
      mixpanel.reset();
    } catch (error) {
      console.error('Error resetting user:', error);
    }
  },
  
  // Specific button tracking for the requested buttons
  trackConnexionButton: (location = 'Unknown') => {
    track('Button Click', { 
      buttonName: 'Connexion', 
      pageName: location,
      buttonCategory: 'Authentication'
    });
  },
  
  trackCommencerButton: (location = 'Unknown') => {
    track('Button Click', { 
      buttonName: 'Commencer', 
      pageName: location,
      buttonCategory: 'Navigation'
    });
  },
  
  trackValiderButton: (location = 'Unknown', formType = 'Unknown') => {
    track('Button Click', { 
      buttonName: 'Valider', 
      pageName: location,
      formType,
      buttonCategory: 'Form'
    });
  },
  
  trackTerminerButton: (location = 'Unknown', activityType = 'Unknown') => {
    track('Button Click', { 
      buttonName: 'Terminer', 
      pageName: location,
      activityType,
      buttonCategory: 'Completion'
    });
  }
};

export default Analytics; 